module.exports = __webpack_public_path__ + "static/media/cell phone.dab0e7eb.svg";